
import QbIcon from "../../assets/icons/qb-ball-only-photo.svg"

export const QuickbookSyncBtn = ({ syncLabel = "Sync to", disabled, syncAction }) => {

    return (
        <div>
            <div className="qb-btn-width" onClick={syncAction}>
                <img alt="quickbook" src={QbIcon} className="qb-icon" />
                <div style={{ lineHeight: "1", margin: "4px" }}>
                    <label className="sync-status-label">{syncLabel}</label><br />
                    <label className="sync-lable-qb">QuickBooks</label>
                </div>
            </div >
            {disabled && <div className="qb-disable">
            </div>}
        </div>

    )
}